import {
  COOKIE_CONSENT_KEY,
  CURRENT_COOKIE_VERSION,
  DEFAULT_CONSENT,
  DEFAULT_NECESSARY_ONLY_CONSENT,
} from '../utils/cookieConstants';

/**
 * Get cookie consent settings from localStorage
 * Returns null if not set or version mismatch
 */
export const getStoredConsent = () => {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== CURRENT_COOKIE_VERSION) {
      return null;
    }
    return parsed;
  } catch (error) {
    console.error('Failed to read cookie consent from localStorage:', error);
    return null;
  }
};

/**
 * Save cookie consent settings to localStorage
 */
export const saveConsent = (consentPartial) => {
  try {
    const consent = {
      version: CURRENT_COOKIE_VERSION,
      necessary: true, // Always true
      analytics: Boolean(consentPartial.analytics),
      updatedAt: new Date().toISOString(),
    };
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
    return consent;
  } catch (error) {
    console.error('Failed to save cookie consent to localStorage:', error);
    return null;
  }
};

/**
 * Save accept-all consent
 */
export const saveAcceptAll = () => {
  return saveConsent({
    ...DEFAULT_CONSENT,
    analytics: true,
  });
};

/**
 * Save necessary-only consent
 */
export const saveNecessaryOnly = () => {
  return saveConsent({
    ...DEFAULT_NECESSARY_ONLY_CONSENT,
    analytics: false,
  });
};

/**
 * Clear stored consent
 */
export const clearConsent = () => {
  try {
    localStorage.removeItem(COOKIE_CONSENT_KEY);
  } catch (error) {
    console.error('Failed to clear cookie consent:', error);
  }
};
